import { createAction } from "@reduxjs/toolkit";

export const subscribeToOrderList = createAction("subscribeToOrderList");
export const unsubscribeToOrderList = createAction("unsubscribeToOrderList");
